/**
 * @returns 返回一个和38位的字母数字随机ID
 * 用于生成sessionId
 */
export const randomId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
};
